import browseGroupsButtonsComponentUrl from './browseGroupsButtonsComponent.html';

class BrowseGroupsButtonsComponent {
  constructor(Utils) {
    'ngInject';

    Object.assign(this, { Utils });
  }

  $onInit() {
    this._setOtherGroups();
  }

  _setOtherGroups() {
    this.previousGroupId = '';
    this.nextGroupId = '';

    if (this.groupsCollection.length <= 1) {
      return;
    }

    const sortedGroups = this.Utils.sortBy(this.groupsCollection, 'name');
    const currentGroupIndex = sortedGroups.findIndex((group) => this.currentGroupId === group.id);

    this.previousGroupId = currentGroupIndex !== 0 && sortedGroups[currentGroupIndex - 1].id;
    this.nextGroupId =
      currentGroupIndex !== sortedGroups.length - 1 && sortedGroups[currentGroupIndex + 1].id;
  }
}

export default {
  controller: BrowseGroupsButtonsComponent,
  controllerAs: 'ctrl',
  templateUrl: browseGroupsButtonsComponentUrl,
  bindings: {
    groupsCollection: '<',
    currentGroupId: '<',
    navigateToAnother: '&',
  },
};
